module.exports = __webpack_public_path__ + "static/media/sub_menu_skincare_pro.a136a0a8.png";